import React from 'react';
import Input, { IInputProps } from '../../components/bootstrap/forms/Input';
import FormGroup from '../../components/bootstrap/forms/FormGroup';

const CustomTextInput = (inputProps: IInputProps) => {
	return (
		<FormGroup id={inputProps.id} label={inputProps.placeholder} isFloating>
			<Input {...inputProps} />
		</FormGroup>
	);
};

export default CustomTextInput;
